import * as api from "@/api/williams/region";
import { RegionSelection } from "../../components/dialogs/RegionSelection";
import { useModalDialog } from "@/hooks";
import { useQuery } from "react-query";
import { Region } from "@/api/williams/region";

export type RegionLookupProps = {
  selectedRegions: Region[];
  onAccept: (selected: Region[]) => void;
};

export function useRegionsLookup() {
  const modal = useModalDialog();

  const regions = useQuery("regions", api.getRegions, {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  function showDialog(props: RegionLookupProps) {
    modal.show(RegionSelection, {
      caption: "Select Regions",
      options: regions.data ?? [],
      selected: props.selectedRegions,
      onAccept: (regions) => props.onAccept(regions),
    });
  }

  return { showDialog };
}
